import SiafLiteApiRepository from "../../external/siafLiteApi";

class CadastrosService {
  constructor() {
    this.urlBase = "/cadastros";
    this.urlBaseEvent = `/event${this.urlBase}`;
  }

  cadastrarEmpresa(body) {
    return new SiafLiteApiRepository(`${this.urlBaseEvent}/empresas`).post(
      body,
    );
  }

  cadastrarContador(body) {
    return new SiafLiteApiRepository(`${this.urlBaseEvent}/contadores`).post(
      body,
    );
  }

  validarEmpresaCadastrada(cnpjCpf) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/validar-cnpj-cpf`,
    ).patch({
      cnpjCpf,
    });
  }

  validarContadorCadastrado(cnpjCpf) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/validar-contador-cadastrado`,
    ).patch({
      cnpjCpf,
    });
  }

  validarUsuarioCadastrado(emailUsuario) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/validar-email-usuario`,
    ).patch({
      emailUsuario,
    });
  }

  getCidades(ufid) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/cidades/${ufid}`,
    ).get();
  }

  getPesquisaSatisfacao(hash) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/pesquisa-satisfacao`,
    ).patch({ token: hash });
  }

  updatePesquisaSatisfacao(body) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/pesquisa-satisfacao/update`,
    ).patch(body);
  }

  getAgendamentoServico(body) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/agendamento-servico`,
    ).patch(body);
  }

  createAgendamentoServico(body) { 
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/agendamento-servico`,
    ).post(body);
  }

  updateServicoRecorrente(body) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/servico-recorrente`,
    ).patch(body);
  }
}

export default CadastrosService;
